export default class PublicPersonValidPayload {

    currentIsValid = true;

}
